"use strict";
import { checkPermission } from "./checkPermission";
import { usePermissions } from "./usePermissions";
export function usePermissionCheck(permissions) {
  const [shellPermissions] = usePermissions();
  return checkPermission(shellPermissions, permissions);
}
